module.exports = {
	en: {
		contactForm: {
			message: {
				label: 'Message',
			},
			firstName: {
				label: 'First name',
				placeholder: 'Your first name',
			},
			lastName: {
				label: 'Last name',
				placeholder: 'Your last name',
			},
			email: {
				label: 'Email',
				placeholder: 'Your email',
			},
			phone: {
				label: 'Phone',
				placeholder: 'Your phone number'
			},
			gdpr:
				'I consent to have this website store my submitted contact information so they can respond to my enquiry.',
			send: 'Send',
			success: 'Thank you! We will get back to you shortly.',
		},
		newsletterForm: {
			email: {
				label: 'Email',
				placeholder: 'Your email',
			},
			gdpr:
				'By subscribing, you authorize superhuit to store your personal data and to send you personalized emails. For more information, please refer to our <a href="/todo">Privacy Policy</a>.',
			success: 'Thank you for subscribing!',
		},
		errors: {
			default: 'Please enter your',
			email: 'Please enter a valid email',
			gdpr: 'GDPR is required',
		},
	},
	fr: {
		contactForm: {
			message: {
				label: 'Message',
			},
			firstName: {
				label: 'Prénom',
				placeholder: 'Votre prénom',
			},
			lastName: {
				label: 'Nom',
				placeholder: 'Votre nom',
			},
			email: {
				label: 'Email',
				placeholder: 'Votre email',
			},
			phone: {
				label: 'Téléphone',
				placeholder: 'Votre numéro de téléphone'
			},
			gdpr: `J’accepte que superhuit conserve les coordonnées que j'ai fournies afin de pouvoir répondre à mon message.`,
			send: 'Envoyer',
			success: 'Merci! À tantôt.',
		},
		newsletterForm: {
			email: {
				label: 'Email',
				placeholder: 'Your email',
			},
			gdpr:
				'By subscribing, you authorize superhuit to store your personal data and to send you personalized emails. For more information, please refer to our <a href="/todo">Privacy Policy</a>.',
			success: 'Thank you for subscribing!',
		},
		errors: {
			default: 'Veuillez entrer votre',
			email: 'Veuillez entrer un email valide',
			gdpr: 'Veuillez accepter les conditions',
		},
	},
};
